import EnumSet from 'Services/enumSet'

interface IHistoryOrigin extends EnumSet {
  none: number
  system: number
  customer: number
  supplier: number
}

const historyOrigin = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  system: { value: 1, description: 'Sistema' },
  customer: { value: 2, description: 'Solicitante' },
  supplier: { value: 3, description: 'Fornecedor' },
}) as IHistoryOrigin

export default historyOrigin